/** Русская локаль компонентов PrimeVue (календарь, пустые состояния, подписи). */
export const primeVueLocaleRu = {
  startsWith: 'Начинается с',
  contains: 'Содержит',
  notContains: 'Не содержит',
  endsWith: 'Заканчивается на',
  equals: 'Равно',
  notEquals: 'Не равно',
  noFilter: 'Без фильтра',
  lt: 'Меньше',
  lte: 'Меньше или равно',
  gt: 'Больше',
  gte: 'Больше или равно',
  dateIs: 'Дата',
  dateIsNot: 'Дата не',
  dateBefore: 'Дата до',
  dateAfter: 'Дата после',
  clear: 'Очистить',
  apply: 'Применить',
  matchAll: 'Совпадают все',
  matchAny: 'Совпадает любое',
  addRule: 'Добавить правило',
  removeRule: 'Удалить правило',
  accept: 'Да',
  reject: 'Нет',
  choose: 'Выбрать',
  upload: 'Загрузить',
  cancel: 'Отмена',
  completed: 'Готово',
  pending: 'Ожидает',
  fileSizeTypes: ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ЙБ'],
  dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  monthNamesShort: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек',
  ],
  chooseYear: 'Выбрать год',
  chooseMonth: 'Выбрать месяц',
  chooseDate: 'Выбрать дату',
  prevDecade: 'Предыдущее десятилетие',
  nextDecade: 'Следующее десятилетие',
  prevYear: 'Предыдущий год',
  nextYear: 'Следующий год',
  prevMonth: 'Предыдущий месяц',
  nextMonth: 'Следующий месяц',
  prevHour: 'Предыдущий час',
  nextHour: 'Следующий час',
  prevMinute: 'Предыдущая минута',
  nextMinute: 'Следующая минута',
  prevSecond: 'Предыдущая секунда',
  nextSecond: 'Следующая секунда',
  am: 'AM',
  pm: 'PM',
  today: 'Сегодня',
  weekHeader: 'Нед',
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: 'dd.mm.yy',
  weak: 'Слабый',
  medium: 'Средний',
  strong: 'Сильный',
  passwordPrompt: 'Введите пароль',
  emptyFilterMessage: 'Ничего не найдено',
  searchMessage: 'Найдено: {0}',
  selectionMessage: 'Выбрано: {0}',
  emptySelectionMessage: 'Ничего не выбрано',
  emptySearchMessage: 'Ничего не найдено',
  emptyMessage: 'Нет вариантов',
  /** Подписи для скринридеров: без них кнопки диалогов и списков звучат по-английски. */
  aria: {
    trueLabel: 'Да',
    falseLabel: 'Нет',
    nullLabel: 'Не выбрано',
    star: '1 звезда',
    stars: 'Звёзд: {star}',
    selectAll: 'Выбраны все',
    unselectAll: 'Выбор снят со всех',
    close: 'Закрыть',
    previous: 'Назад',
    next: 'Вперёд',
    navigation: 'Навигация',
    scrollTop: 'Наверх',
    moveTop: 'В начало',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    moveBottom: 'В конец',
    moveToTarget: 'Перенести',
    moveToSource: 'Вернуть',
    moveAllToTarget: 'Перенести все',
    moveAllToSource: 'Вернуть все',
    pageLabel: 'Страница {page}',
    firstPageLabel: 'Первая страница',
    lastPageLabel: 'Последняя страница',
    nextPageLabel: 'Следующая страница',
    prevPageLabel: 'Предыдущая страница',
    rowsPerPageLabel: 'Строк на странице',
    jumpToPageDropdownLabel: 'Перейти к странице',
    jumpToPageInputLabel: 'Номер страницы',
    selectRow: 'Строка выбрана',
    unselectRow: 'Выбор строки снят',
    expandRow: 'Строка раскрыта',
    collapseRow: 'Строка свёрнута',
    showFilterMenu: 'Показать фильтр',
    hideFilterMenu: 'Скрыть фильтр',
    filterOperator: 'Условие фильтра',
    filterConstraint: 'Ограничение фильтра',
    editRow: 'Изменить строку',
    saveEdit: 'Сохранить',
    cancelEdit: 'Отменить',
    listView: 'Списком',
    gridView: 'Плиткой',
    slide: 'Слайд',
    slideNumber: '{slideNumber}',
    zoomImage: 'Увеличить изображение',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    rotateRight: 'Повернуть вправо',
    rotateLeft: 'Повернуть влево',
    listLabel: 'Список вариантов',
  },
}
